// @flow

import { startRequest, finishRequest } from "@store/utils";

export const setLoading = (state: Object) => () => {
  return {
    ...state,
    app: {
      ...startRequest(state.app),
    },
  };
};

export const onGetAppClientSettingsSuccess = (state: Object) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    app: {
      ...finishRequest(state.app),
      configuration: payload,
    },
  };
};

export const onGetAppClientSettingsError = (state: Object) => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    app: {
      ...finishRequest(state.app),
    },
  };
};

export const onUpdateAppClientSettingsSuccess = (state: Object) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    app: {
      ...finishRequest(state.app),
      configuration: payload,
    },
  };
};

export const onUpdateAppClientSettingsError = (state: Object) => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    app: {
      ...finishRequest(state.app),
    },
  };
};
